import React from 'react';
import AdminSiteAboutPageFields from './AdminSiteAboutPageFields';
import AdminSiteHeroActionsFields from './AdminSiteHeroActionsFields';
import AdminSiteImageField from './AdminSiteImageField';
import { setPageCopySection } from './adminSiteCopyFields';
function Field({ id, label, value, onChange, multiline, hint }) {
  return (
    <div className="col-12">
      <label className="form-label" htmlFor={id}>
        {label}
      </label>
      {multiline ? (
        <textarea
          id={id}
          className="form-control"
          rows={typeof multiline === 'number' ? multiline : 3}
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
      ) : (
        <input id={id} className="form-control" value={value} onChange={(e) => onChange(e.target.value)} />
      )}
      {hint ? <Hint>{hint}</Hint> : null}
    </div>
  );
}

function Hint({ children }) {
  return <div className="form-text">{children}</div>;
}

export default function AdminSiteContentFields({ form, setField, sessionToken, onPersistHeroImage }) {
  const home = form.page_copy?.home || {};
  const setHome = (patch) => setPageCopySection(form, setField, 'home', patch);

  return (
    <>
      <div className="card border shadow-sm mb-3">
        <div className="card-header py-2">
          <h2 className="h6 mb-0">Home page hero</h2>
          <p className="small text-muted mb-0 mt-1">Headline, hero image, badge, trust pills, and buttons.</p>
        </div>
        <div className="card-body">
          <div className="row g-3">
            <Field id="hero-title" label="Headline" value={form.hero_title} onChange={(v) => setField('hero_title', v)} />
            <Field
              id="hero-subtitle"
              label="Subtitle"
              value={form.hero_subtitle}
              onChange={(v) => setField('hero_subtitle', v)}
            />
            <Field
              id="hero-description"
              label="Description"
              value={form.hero_description}
              onChange={(v) => setField('hero_description', v)}
              multiline={3}
            />
            <AdminSiteImageField
              id="hero-bg-image"
              label="Hero photo (optional)"
              value={form.seo_home_og_image || ''}
              onChange={(v) => setField('seo_home_og_image', v)}
              sessionToken={sessionToken}
              focalPreviewAspect="21 / 9"
              onPersist={onPersistHeroImage}
              focalPoint={{
                x: home.hero_image_focal_x,
                y: home.hero_image_focal_y,
              }}
              onFocalChange={(x, y) => setHome({ hero_image_focal_x: x, hero_image_focal_y: y })}
              hint="Wide lifestyle photo works best. After uploading, click the preview to choose which part shows in the hero banner. Also used for social sharing. Leave empty to use the first featured product photo."
            />
            <Field
              id="hero-badge"
              label="Badge on hero photo"
              value={home.hero_badge || ''}
              onChange={(v) => setHome({ hero_badge: v })}
              hint='Short label on the image frame, e.g. "Handcrafted" or "Festive 2026".'
            />
            <Field
              id="hero-picks-label"
              label="Floating picks card title"
              value={home.hero_picks_label || ''}
              onChange={(v) => setHome({ hero_picks_label: v })}
              hint={"Title above featured mini-products on the hero, e.g. Editor's picks."}
            />
            <div className="col-12">
              <p className="small fw-semibold text-muted mb-2 mt-1">Trust pills (under hero buttons)</p>
            </div>
            <Field
              id="hero-trust-1"
              label="Trust pill 1"
              value={home.hero_trust_1 || ''}
              onChange={(v) => setHome({ hero_trust_1: v })}
            />
            <Field
              id="hero-trust-2"
              label="Trust pill 2"
              value={home.hero_trust_2 || ''}
              onChange={(v) => setHome({ hero_trust_2: v })}
            />
            <Field
              id="hero-trust-3"
              label="Trust pill 3"
              value={home.hero_trust_3 || ''}
              onChange={(v) => setHome({ hero_trust_3: v })}
              hint="Leave blank to use Footer location from Contact settings (e.g. Ahmedabad, India)."
            />
          </div>
        </div>
      </div>

      <AdminSiteHeroActionsFields form={form} setField={setField} />

      <div className="card border shadow-sm mb-3">
        <div className="card-header py-2">
          <h2 className="h6 mb-0">Home page — Our story strip</h2>
        </div>
        <div className="card-body row g-3">
          <Field
            id="home-about-title"
            label="Section title"
            value={form.home_about_title}
            onChange={(v) => setField('home_about_title', v)}
          />
          <Field
            id="home-about-text"
            label="Body text"
            value={form.home_about_text}
            onChange={(v) => setField('home_about_text', v)}
            multiline={4}
          />
          <Field
            id="home-about-tagline"
            label="Tagline (handwritten style)"
            value={form.home_about_tagline}
            onChange={(v) => setField('home_about_tagline', v)}
          />
        </div>
      </div>

      <div className="card border shadow-sm mb-3">
        <div className="card-header py-2">
          <h2 className="h6 mb-0">About page — hero & story</h2>
        </div>
        <div className="card-body row g-3">
          <Field
            id="about-hero-title"
            label="Page title"
            value={form.about_hero_title}
            onChange={(v) => setField('about_hero_title', v)}
          />
          <Field
            id="about-hero-subtitle"
            label="Subtitle under title"
            value={form.about_hero_subtitle}
            onChange={(v) => setField('about_hero_subtitle', v)}
          />
          <Field
            id="about-para1"
            label="Paragraph 1"
            value={form.about_para1}
            onChange={(v) => setField('about_para1', v)}
            multiline={4}
          />
          <Field
            id="about-para2"
            label="Paragraph 2"
            value={form.about_para2}
            onChange={(v) => setField('about_para2', v)}
            multiline={4}
          />
          <Field
            id="about-para3"
            label="Paragraph 3"
            value={form.about_para3}
            onChange={(v) => setField('about_para3', v)}
            multiline={4}
          />
          <Field
            id="about-tagline"
            label="Closing tagline"
            value={form.about_tagline}
            onChange={(v) => setField('about_tagline', v)}
          />
        </div>
      </div>

      <AdminSiteAboutPageFields form={form} setField={setField} />
    </>
  );
}
